// removed by extract-text-webpack-plugin
module.exports = {"wkLoading":"wkLoading__3Q152","splashContainer":"splashContainer__3TDHO","indexTips":"indexTips__3kaWM","title":"title__3ShAK","skWave":"skWave__28OfN","skRect":"skRect__2gFjv","sk-waveStretchDelay":"sk-waveStretchDelay__2As3s","skRect1":"skRect1__1TqIe","skRect2":"skRect2__2-iI_","skRect3":"skRect3__3z5Mc","skRect4":"skRect4__EenZh","skRect5":"skRect5__2IDTl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WK/WKLoading/index.css
// module id = 456
// module chunks = 3